/**
 * @generated SignedSource<<23ddd44bf51a2859a912b5772d66daf6>>
 * @relayHash c1da554fa525643c31de943858cfa545
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 448a5607a2cc42de6e2004dbb22c04163afbd333c7ca697b8f20e472973dd3ee

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type PublishModalContextPublishModalWithMoreOptionsQuery$variables = {
  contentId?: string | null | undefined;
};
export type PublishModalContextPublishModalWithMoreOptionsQuery$data = {
  readonly singleContent: {
    readonly id: string | null | undefined;
    readonly schedulePublishInfo: {
      readonly date: string | null | undefined;
      readonly minorEdit: boolean | null | undefined;
      readonly restrictions: {
        readonly read: {
          readonly group: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string | null | undefined;
                readonly name: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly user: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly accountId: string | null | undefined;
                readonly displayName: string | null | undefined;
                readonly email: string | null | undefined;
                readonly permissionType: SitePermissionType | null | undefined;
                readonly profilePicture: {
                  readonly path: string;
                } | null | undefined;
                readonly publicName: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly update: {
          readonly group: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string | null | undefined;
                readonly name: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly user: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly accountId: string | null | undefined;
                readonly displayName: string | null | undefined;
                readonly email: string | null | undefined;
                readonly permissionType: SitePermissionType | null | undefined;
                readonly profilePicture: {
                  readonly path: string;
                } | null | undefined;
                readonly publicName: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly targetLocation: {
        readonly destinationSpace: {
          readonly alias: string | null | undefined;
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
        } | null | undefined;
        readonly parentId: string | null | undefined;
      } | null | undefined;
      readonly targetType: string | null | undefined;
      readonly versionComment: string | null | undefined;
    } | null | undefined;
    readonly space: {
      readonly id: string | null | undefined;
    } | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type PublishModalContextPublishModalWithMoreOptionsQuery = {
  response: PublishModalContextPublishModalWithMoreOptionsQuery$data;
  variables: PublishModalContextPublishModalWithMoreOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "alias": "user",
    "concreteType": "ConfluencePersonConnection",
    "kind": "LinkedField",
    "name": "personConnection",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluencePersonEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "ConfluencePerson",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "email"
              },
              {
                "kind": "ScalarField",
                "name": "permissionType"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "ScalarField",
                "name": "accountId"
              },
              {
                "kind": "ScalarField",
                "name": "publicName"
              },
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "PaginatedGroupList",
    "kind": "LinkedField",
    "name": "group",
    "plural": false,
    "selections": [
      {
        "concreteType": "GroupEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "Group",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "name"
              },
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "SchedulePublishInfo",
        "kind": "LinkedField",
        "name": "schedulePublishInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "date"
          },
          {
            "kind": "ScalarField",
            "name": "versionComment"
          },
          {
            "kind": "ScalarField",
            "name": "minorEdit"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          },
          {
            "concreteType": "TargetLocation",
            "kind": "LinkedField",
            "name": "targetLocation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "parentId"
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "destinationSpace",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "alias"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "ScheduledRestrictions",
            "kind": "LinkedField",
            "name": "restrictions",
            "plural": false,
            "selections": [
              {
                "concreteType": "ScheduledRestriction",
                "kind": "LinkedField",
                "name": "update",
                "plural": false,
                "selections": (v2/*: any*/)
              },
              {
                "concreteType": "ScheduledRestriction",
                "kind": "LinkedField",
                "name": "read",
                "plural": false,
                "selections": (v2/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PublishModalContextPublishModalWithMoreOptionsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PublishModalContextPublishModalWithMoreOptionsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "c1da554fa525643c31de943858cfa545",
    "id": "448a5607a2cc42de6e2004dbb22c04163afbd333c7ca697b8f20e472973dd3ee",
    "metadata": {},
    "name": "PublishModalContextPublishModalWithMoreOptionsQuery",
    "operationKind": "query",
    "text": "query PublishModalContextPublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id,type,space{id},schedulePublishInfo{date,versionComment,minorEdit,targetType,targetLocation{parentId,destinationSpace{id,key,alias}},restrictions{update{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}},read{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}}}}}}"
  }
};
})();

(node as any).hash = "b6a8ac472557078317109dfe61be9f46";

export default node;
